/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_gf_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter a rotor radius and a value to convert.`)
};

const es_gf_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Introduce un radio de rotor y un valor para convertir.`)
};

const de_gf_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geben Sie einen Rotorradius und einen Wert zur Umrechnung ein.`)
};

const nl_gf_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voer een rotorstraal en een waarde in om om te rekenen.`)
};

const fr_gf_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrez un rayon de rotor et une valeur à convertir.`)
};

const it_gf_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserisci un raggio del rotore e un valore da convertire.`)
};

const pt_br2_gf_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informe um raio de rotor e um valor para converter.`)
};

const pt_gf_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Introduza um raio do rotor e um valor para converter.`)
};

const ja_gf_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ローター半径と値を入力して変換してください。`)
};

const zh_gf_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`输入转子半径和数值以进行换算。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const gf_hint = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.gf_hint(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("gf_hint", locale)
	if (locale === "en") return en_gf_hint(inputs)
	if (locale === "es") return es_gf_hint(inputs)
	if (locale === "de") return de_gf_hint(inputs)
	if (locale === "nl") return nl_gf_hint(inputs)
	if (locale === "fr") return fr_gf_hint(inputs)
	if (locale === "it") return it_gf_hint(inputs)
	if (locale === "pt-BR") return pt_br2_gf_hint(inputs)
	if (locale === "pt") return pt_gf_hint(inputs)
	if (locale === "ja") return ja_gf_hint(inputs)
	return zh_gf_hint(inputs)
};